import { Navigate } from "react-router-dom";

const NotFound = () => {
  // localStorage.clear();
  return <Navigate to="/user/dashboard" />;
};

export default NotFound;
